module.exports = __webpack_public_path__ + "img/ab_testing_server.61ef3ec5.png";